const platformUsageOptions: { [key: string]: string } = {
  API: 'API',
  Dashboard: 'Dashboard',
  'Partner Product': 'Partner Product',
  'API and Dashboard': 'API and Dashboard',
};

export default platformUsageOptions;
